import { useServices } from "../app/services.ts";
import { duration } from "../data/display.ts";
import { Icon } from "../ui/Icon.tsx";
import { usePlayer } from "./player.ts";
import styles from "./Conversation.module.css";

/** The bar on top while a voice message plays: who, which section, progress, speed. */
export function PlaybackBar() {
  const { player } = useServices();
  const state = usePlayer(player);
  const track = state.track;
  if (!track) return null;
  const section = track.sections.findLast((s) => s.startMs <= state.positionMs);
  const progress = track.durationMs ? Math.min(100, (state.positionMs / track.durationMs) * 100) : 0;
  return (
    <div className={styles.playback}>
      <button className={styles.playButton} onClick={() => player.toggle()} aria-label={state.playing ? "Pause" : "Weiter"}>
        <Icon name={state.playing ? "pause" : "play"} size={20} />
      </button>
      <span className={styles.who}>
        <b>{track.senderName}</b>
        {section && ` · ${section.title}`}
      </span>
      <span className={styles.progress} onClick={(e) => {
        const box = e.currentTarget.getBoundingClientRect();
        player.seek(((e.clientX - box.left) / box.width) * track.durationMs);
      }}>
        <span style={{ width: `${progress}%` }} />
      </span>
      <span className={styles.time}>
        {duration(state.positionMs)} / {duration(track.durationMs)}
      </span>
      <button className={styles.rate} onClick={() => player.nextRate()} aria-label="Geschwindigkeit">
        {String(state.rate).replace(".", ",")}×
      </button>
      <button className={styles.close} onClick={() => player.stop()} aria-label="Wiedergabe beenden">
        <Icon name="close" size={20} />
      </button>
    </div>
  );
}
